import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const ProtectedAdminRoute = ({ children }) => {
    // Usiamo le nuove chiavi standardizzate
    const authToken = localStorage.getItem('auth_token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    // Log per debugging che usa le nuove chiavi
    console.log('Debug ProtectedAdminRoute:', {
        authToken,
        user,
        hasToken: !!authToken,
        isAdmin: user.role === 'admin'
    });

    // Verifica del token di autenticazione
    if (!authToken) {
        console.log('Redirect: Token di autenticazione non trovato');
        return <Navigate to="/admin/login" />;
    }

    // Verifica del ruolo admin
    if (!user || user.role !== 'admin') {
        console.log('Redirect: Utente non autorizzato (ruolo non admin)');
        return <Navigate to="/admin/login" />;
    }

    // Se tutto è ok, renderizza i componenti figli
    return children;
};

// Manteniamo la validazione delle props
ProtectedAdminRoute.propTypes = {
    children: PropTypes.node.isRequired
};

export default ProtectedAdminRoute;